// Message Origin
const origin = "*";

// Handle view event
export const updateDashboard = (visible: boolean) => {
    window.parent.postMessage(
        {
            message: "updateDashboard",
            data: { visible },
        },
        origin
    );
    console.log(`Dashboard visibility updated: ${visible}`);
};

// Send message to clear map selection
export const handleClearSelection = () => {
    window.parent.postMessage(
        {
            message: "clearMapSelection",
        },
        origin
    );
    console.log("Clear map selection message sent.");
}

export const clearAllLayers = () => {
    // Send message to clear map layer overlay selection
    // window.parent.postMessage(
    //     {
    //         message: "clearOverlayLayers",
    //     },
    //     origin
    // );
    // console.log("Clear map overlay layers message sent.");

    // Send message to clear map programmatic layer selection
    window.parent.postMessage(
        {
            message: "clearProgrammaticLayers",
        },
        origin
    );
    console.log("Clear map programmatic layers message sent.");

    // Send message to clear map symbolic layer selection
    window.parent.postMessage(
        {
            message: "clearSymbolicLayers",
        },
        origin
    );
    console.log("Clear map symbolic layers message sent.");
}

export const clearSymbolicLayers = () => {
    // Send message to clear map symbolic layer selection
    window.parent.postMessage(
        {
            message: "clearSymbolicLayers",
        },
        origin
    );
    console.log("Clear map symbolic layers message sent.");
}